<template>
  <div class="group-detail">
    <div class="content-wrapper">
      <div class="main-content">
        <div class="main-content__msg-box">
          <ErrorCsv :errorMessages="errors" />
        </div>
      </div>
      <div class="button-container">
        <div
          @click="confirm"
          class="import-button"
          :disabled="isAssignment"
        >
          Assignment
        </div>
      </div>
    </div>
    <Loading :isLoading="isAssignment" />
  </div>
</template>

<script lang="ts">
import _ from 'lodash'
import ErrorCsv from '@/components/parts/ErrorCsv.vue';
import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator'
import { AssignmentStatus } from '@/store/groups/formation/types';
import Loading from '@/components/parts/modal/Loading.vue'

@Component({
  components: {
    ErrorCsv,
    Loading,
  },
})
export default class AssignBooth extends Vue {
  @Prop({ required: true }) selectedAssignment!: AssignmentStatus

  errors: string|null = null

  isAssignment: boolean = false

  warnings: string[] = []

  confirm() {
    if (this.isAssignment) {
      return
    }
    this.$bvModal.msgBoxConfirm('Assign booths. Is it OK?')
      .then((isOk) => {
        if (isOk) {
          this.assignBooth()
        }
      })
  }

  assignBooth() {
    if (_.isNull(this.selectedAssignment)) {
      throw Error('ブースアサイン時の年度学期が選択されていません')
    }
    this.isAssignment = true

    this.$store.dispatch('assignGroupBooths', {
      assignment: this.selectedAssignment,
    })
      .then(() => {
        this.$bvModal.msgBoxOk('Success !')
          .then(() => this.$emit('complete'))
      })
      .catch((error) => {
        this.errors = error
      })
      .finally(() => { this.isAssignment = false })
  }

  checkError(error: string) {
    this.errors = error
  }
}

</script>

<style scoped>
h1 {
  text-align: center;
  margin-bottom:20px;
}

.sub-title {
  padding:10px;
  margin-bottom: 20px;
  background: #DDEAF6;
  display: flex;
  align-items: center;
}

.main-content {
  padding: 20px;
  border-radius: 20px;
  margin-bottom:20px;
  min-height: 500px;
}

.content-wrapper {
  background: #D8D8D8;
  padding: 20px 20px;
}

.button-container {
  display: flex;
  justify-content: center;
}

.import-button {
  margin-left:10px;
  display: block;
  text-decoration: none;
  color: #ffffff;
  min-width: 120px;
  font-size:15px;
  line-height: 15px;
  text-align: center;
  padding: 10px;
  border: 3px solid #1cc8a0;
  border-radius: 20px;
  cursor: pointer;
  transition: .2s;
  user-select:none;
  background: #1cc8a0;
}

.import-button:hover {
  background: #fff;
  color: #1cc8a0;
}

.main-content p {
  display: block;
  text-align: left;
  margin:10px 0;
  font-weight: bold;
  text-align: left;
  margin:10px 0;
  font-weight: bold;
}

.main-content__csv-box {
  margin-bottom:70px;
}
</style>
